import { createFileRoute } from '@tanstack/react-router';
import { KioskNewPatronFillingExperiencePage } from '../pages';

export interface SearchParams {
  formId?: string;
  packetId?: string;
}

export const Route = createFileRoute('/kiosk/new-patron_/$locationId')({
  component: KioskNewPatronFillingExperiencePage,
  validateSearch: (search: SearchParams): SearchParams => {
    return search;
  },
});
